 "use client";

import React from 'react';
import { CartProvider } from './shopping/CartContext'; // Assurez-vous que ce chemin est correct
import { WishlistProvider } from './wishlist/WishlistContext';

// Ce composant enveloppe les enfants avec tous les fournisseurs de contexte nécessaires.
export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <CartProvider>
      <WishlistProvider>
        {children}
      </WishlistProvider>
    </CartProvider>
  );
}